import { render, staticRenderFns } from "./v-contact.vue?vue&type=template&id=ca1167f0&"
import script from "./v-contact.vue?vue&type=script&lang=js&"
export * from "./v-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports